/**
 * Country names in English and German (ISO 3166-1 alpha-2 codes).
 * Keys are the country codes used in the app; use getCountryCodes() for the ordered list.
 */
export const COUNTRY_NAMES: Record<string, { en: string; de: string }> = {
  AD: { en: "Andorra", de: "Andorra" },
  AE: { en: "United Arab Emirates", de: "Vereinigte Arabische Emirate" },
  AF: { en: "Afghanistan", de: "Afghanistan" },
  AG: { en: "Antigua and Barbuda", de: "Antigua und Barbuda" },
  AI: { en: "Anguilla", de: "Anguilla" },
  AL: { en: "Albania", de: "Albanien" },
  AM: { en: "Armenia", de: "Armenien" },
  AO: { en: "Angola", de: "Angola" },
  AQ: { en: "Antarctica", de: "Antarktis" },
  AR: { en: "Argentina", de: "Argentinien" },
  AS: { en: "American Samoa", de: "Amerikanisch-Samoa" },
  AT: { en: "Austria", de: "Österreich" },
  AU: { en: "Australia", de: "Australien" },
  AW: { en: "Aruba", de: "Aruba" },
  AX: { en: "Åland Islands", de: "Åland" },
  AZ: { en: "Azerbaijan", de: "Aserbaidschan" },
  BA: { en: "Bosnia and Herzegovina", de: "Bosnien und Herzegowina" },
  BB: { en: "Barbados", de: "Barbados" },
  BD: { en: "Bangladesh", de: "Bangladesch" },
  BE: { en: "Belgium", de: "Belgien" },
  BF: { en: "Burkina Faso", de: "Burkina Faso" },
  BG: { en: "Bulgaria", de: "Bulgarien" },
  BH: { en: "Bahrain", de: "Bahrain" },
  BI: { en: "Burundi", de: "Burundi" },
  BJ: { en: "Benin", de: "Benin" },
  BL: { en: "Saint Barthélemy", de: "Saint-Barthélemy" },
  BM: { en: "Bermuda", de: "Bermuda" },
  BN: { en: "Brunei Darussalam", de: "Brunei" },
  BO: { en: "Bolivia (Plurinational State of)", de: "Bolivien" },
  BQ: {
    en: "Bonaire, Sint Eustatius and Saba",
    de: "Bonaire, Sint Eustatius und Saba",
  },
  BR: { en: "Brazil", de: "Brasilien" },
  BS: { en: "Bahamas", de: "Bahamas" },
  BT: { en: "Bhutan", de: "Bhutan" },
  BV: { en: "Bouvet Island", de: "Bouvetinsel" },
  BW: { en: "Botswana", de: "Botswana" },
  BY: { en: "Belarus", de: "Belarus" },
  BZ: { en: "Belize", de: "Belize" },
  CA: { en: "Canada", de: "Kanada" },
  CC: { en: "Cocos (Keeling) Islands", de: "Kokosinseln" },
  CD: { en: "Congo (Democratic Republic of the)", de: "Kongo (Dem. Rep.)" },
  CF: { en: "Central African Republic", de: "Zentralafrikanische Republik" },
  CG: { en: "Congo", de: "Kongo (Rep.)" },
  CH: { en: "Switzerland", de: "Schweiz" },
  CI: { en: "Côte d'Ivoire", de: "Elfenbeinküste" },
  CK: { en: "Cook Islands", de: "Cookinseln" },
  CL: { en: "Chile", de: "Chile" },
  CM: { en: "Cameroon", de: "Kamerun" },
  CN: { en: "China", de: "China" },
  CO: { en: "Colombia", de: "Kolumbien" },
  CR: { en: "Costa Rica", de: "Costa Rica" },
  CU: { en: "Cuba", de: "Kuba" },
  CV: { en: "Cabo Verde", de: "Kap Verde" },
  CW: { en: "Curaçao", de: "Curaçao" },
  CX: { en: "Christmas Island", de: "Weihnachtsinsel" },
  CY: { en: "Cyprus", de: "Zypern" },
  CZ: { en: "Czechia", de: "Tschechien" },
  DE: { en: "Germany", de: "Deutschland" },
  DJ: { en: "Djibouti", de: "Dschibuti" },
  DK: { en: "Denmark", de: "Dänemark" },
  DM: { en: "Dominica", de: "Dominica" },
  DO: { en: "Dominican Republic", de: "Dominikanische Republik" },
  DZ: { en: "Algeria", de: "Algerien" },
  EC: { en: "Ecuador", de: "Ecuador" },
  EE: { en: "Estonia", de: "Estland" },
  EG: { en: "Egypt", de: "Ägypten" },
  EH: { en: "Western Sahara", de: "Westsahara" },
  ER: { en: "Eritrea", de: "Eritrea" },
  ES: { en: "Spain", de: "Spanien" },
  ET: { en: "Ethiopia", de: "Äthiopien" },
  FI: { en: "Finland", de: "Finnland" },
  FJ: { en: "Fiji", de: "Fidschi" },
  FK: { en: "Falkland Islands (Malvinas)", de: "Falklandinseln" },
  FM: { en: "Micronesia (Federated States of)", de: "Mikronesien" },
  FO: { en: "Faroe Islands", de: "Färöer" },
  FR: { en: "France", de: "Frankreich" },
  GA: { en: "Gabon", de: "Gabun" },
  GB: { en: "United Kingdom", de: "Vereinigtes Königreich" },
  GD: { en: "Grenada", de: "Grenada" },
  GE: { en: "Georgia", de: "Georgien" },
  GF: { en: "French Guiana", de: "Französisch-Guayana" },
  GG: { en: "Guernsey", de: "Guernsey" },
  GH: { en: "Ghana", de: "Ghana" },
  GI: { en: "Gibraltar", de: "Gibraltar" },
  GL: { en: "Greenland", de: "Grönland" },
  GM: { en: "Gambia", de: "Gambia" },
  GN: { en: "Guinea", de: "Guinea" },
  GP: { en: "Guadeloupe", de: "Guadeloupe" },
  GQ: { en: "Equatorial Guinea", de: "Äquatorialguinea" },
  GR: { en: "Greece", de: "Griechenland" },
  GS: {
    en: "South Georgia and the South Sandwich Islands",
    de: "Südgeorgien und die Südlichen Sandwichinseln",
  },
  GT: { en: "Guatemala", de: "Guatemala" },
  GU: { en: "Guam", de: "Guam" },
  GW: { en: "Guinea-Bissau", de: "Guinea-Bissau" },
  GY: { en: "Guyana", de: "Guyana" },
  HK: { en: "Hong Kong", de: "Hongkong" },
  HM: {
    en: "Heard Island and McDonald Islands",
    de: "Heard und McDonaldinseln",
  },
  HN: { en: "Honduras", de: "Honduras" },
  HR: { en: "Croatia", de: "Kroatien" },
  HT: { en: "Haiti", de: "Haiti" },
  HU: { en: "Hungary", de: "Ungarn" },
  ID: { en: "Indonesia", de: "Indonesien" },
  IE: { en: "Ireland", de: "Irland" },
  IL: { en: "Israel", de: "Israel" },
  IM: { en: "Isle of Man", de: "Isle of Man" },
  IN: { en: "India", de: "Indien" },
  IO: {
    en: "British Indian Ocean Territory",
    de: "Britisches Territorium im Indischen Ozean",
  },
  IQ: { en: "Iraq", de: "Irak" },
  IR: { en: "Iran (Islamic Republic of)", de: "Iran" },
  IS: { en: "Iceland", de: "Island" },
  IT: { en: "Italy", de: "Italien" },
  JE: { en: "Jersey", de: "Jersey" },
  JM: { en: "Jamaica", de: "Jamaika" },
  JO: { en: "Jordan", de: "Jordanien" },
  JP: { en: "Japan", de: "Japan" },
  KE: { en: "Kenya", de: "Kenia" },
  KG: { en: "Kyrgyzstan", de: "Kirgisistan" },
  KH: { en: "Cambodia", de: "Kambodscha" },
  KI: { en: "Kiribati", de: "Kiribati" },
  KM: { en: "Comoros", de: "Komoren" },
  KN: { en: "Saint Kitts and Nevis", de: "St. Kitts und Nevis" },
  KP: { en: "Korea (Democratic People's Republic of)", de: "Nordkorea" },
  KR: { en: "Korea (Republic of)", de: "Südkorea" },
  KW: { en: "Kuwait", de: "Kuwait" },
  KY: { en: "Cayman Islands", de: "Kaimaninseln" },
  KZ: { en: "Kazakhstan", de: "Kasachstan" },
  LA: { en: "Lao People's Democratic Republic", de: "Laos" },
  LB: { en: "Lebanon", de: "Libanon" },
  LC: { en: "Saint Lucia", de: "St. Lucia" },
  LI: { en: "Liechtenstein", de: "Liechtenstein" },
  LK: { en: "Sri Lanka", de: "Sri Lanka" },
  LR: { en: "Liberia", de: "Liberia" },
  LS: { en: "Lesotho", de: "Lesotho" },
  LT: { en: "Lithuania", de: "Litauen" },
  LU: { en: "Luxembourg", de: "Luxemburg" },
  LV: { en: "Latvia", de: "Lettland" },
  LY: { en: "Libya", de: "Libyen" },
  MA: { en: "Morocco", de: "Marokko" },
  MC: { en: "Monaco", de: "Monaco" },
  MD: { en: "Moldova (Republic of)", de: "Moldau" },
  ME: { en: "Montenegro", de: "Montenegro" },
  MF: { en: "Saint Martin (French part)", de: "Saint-Martin" },
  MG: { en: "Madagascar", de: "Madagaskar" },
  MH: { en: "Marshall Islands", de: "Marshallinseln" },
  MK: { en: "North Macedonia", de: "Nordmazedonien" },
  ML: { en: "Mali", de: "Mali" },
  MM: { en: "Myanmar", de: "Myanmar" },
  MN: { en: "Mongolia", de: "Mongolei" },
  MO: { en: "Macau", de: "Macau" },
  MP: { en: "Northern Mariana Islands", de: "Nördliche Marianen" },
  MQ: { en: "Martinique", de: "Martinique" },
  MR: { en: "Mauritania", de: "Mauretanien" },
  MS: { en: "Montserrat", de: "Montserrat" },
  MT: { en: "Malta", de: "Malta" },
  MU: { en: "Mauritius", de: "Mauritius" },
  MV: { en: "Maldives", de: "Malediven" },
  MW: { en: "Malawi", de: "Malawi" },
  MX: { en: "Mexico", de: "Mexiko" },
  MY: { en: "Malaysia", de: "Malaysia" },
  MZ: { en: "Mozambique", de: "Mosambik" },
  NA: { en: "Namibia", de: "Namibia" },
  NC: { en: "New Caledonia", de: "Neukaledonien" },
  NE: { en: "Niger", de: "Niger" },
  NF: { en: "Norfolk Island", de: "Norfolkinsel" },
  NG: { en: "Nigeria", de: "Nigeria" },
  NI: { en: "Nicaragua", de: "Nicaragua" },
  NL: { en: "Netherlands", de: "Niederlande" },
  NO: { en: "Norway", de: "Norwegen" },
  NP: { en: "Nepal", de: "Nepal" },
  NR: { en: "Nauru", de: "Nauru" },
  NU: { en: "Niue", de: "Niue" },
  NZ: { en: "New Zealand", de: "Neuseeland" },
  OM: { en: "Oman", de: "Oman" },
  PA: { en: "Panama", de: "Panama" },
  PE: { en: "Peru", de: "Peru" },
  PF: { en: "French Polynesia", de: "Französisch-Polynesien" },
  PG: { en: "Papua New Guinea", de: "Papua-Neuguinea" },
  PH: { en: "Philippines", de: "Philippinen" },
  PK: { en: "Pakistan", de: "Pakistan" },
  PL: { en: "Poland", de: "Polen" },
  PM: { en: "Saint Pierre and Miquelon", de: "Saint-Pierre und Miquelon" },
  PN: { en: "Pitcairn Islands", de: "Pitcairninseln" },
  PR: { en: "Puerto Rico", de: "Puerto Rico" },
  PS: { en: "Palestine, State of", de: "Palästina" },
  PT: { en: "Portugal", de: "Portugal" },
  PW: { en: "Palau", de: "Palau" },
  PY: { en: "Paraguay", de: "Paraguay" },
  QA: { en: "Qatar", de: "Katar" },
  RE: { en: "Réunion", de: "Réunion" },
  RO: { en: "Romania", de: "Rumänien" },
  RS: { en: "Serbia", de: "Serbien" },
  RU: { en: "Russian Federation", de: "Russland" },
  RW: { en: "Rwanda", de: "Ruanda" },
  SA: { en: "Saudi Arabia", de: "Saudi-Arabien" },
  SB: { en: "Solomon Islands", de: "Salomonen" },
  SC: { en: "Seychelles", de: "Seychellen" },
  SD: { en: "Sudan", de: "Sudan" },
  SE: { en: "Sweden", de: "Schweden" },
  SG: { en: "Singapore", de: "Singapur" },
  SH: { en: "Saint Helena, Ascension and Tristan da Cunha", de: "St. Helena" },
  SI: { en: "Slovenia", de: "Slowenien" },
  SJ: { en: "Svalbard and Jan Mayen", de: "Svalbard und Jan Mayen" },
  SK: { en: "Slovakia", de: "Slowakei" },
  SL: { en: "Sierra Leone", de: "Sierra Leone" },
  SM: { en: "San Marino", de: "San Marino" },
  SN: { en: "Senegal", de: "Senegal" },
  SO: { en: "Somalia", de: "Somalia" },
  SR: { en: "Suriname", de: "Suriname" },
  SS: { en: "South Sudan", de: "Südsudan" },
  ST: { en: "Sao Tome and Principe", de: "São Tomé und Príncipe" },
  SV: { en: "El Salvador", de: "El Salvador" },
  SX: { en: "Sint Maarten (Dutch part)", de: "Sint Maarten" },
  SY: { en: "Syrian Arab Republic", de: "Syrien" },
  SZ: { en: "Eswatini", de: "Eswatini" },
  TC: { en: "Turks and Caicos Islands", de: "Turks- und Caicosinseln" },
  TD: { en: "Chad", de: "Tschad" },
  TF: {
    en: "French Southern Territories",
    de: "Französische Süd- und Antarktisgebiete",
  },
  TG: { en: "Togo", de: "Togo" },
  TH: { en: "Thailand", de: "Thailand" },
  TJ: { en: "Tajikistan", de: "Tadschikistan" },
  TK: { en: "Tokelau", de: "Tokelau" },
  TL: { en: "Timor-Leste", de: "Osttimor" },
  TM: { en: "Turkmenistan", de: "Turkmenistan" },
  TN: { en: "Tunisia", de: "Tunesien" },
  TO: { en: "Tonga", de: "Tonga" },
  TR: { en: "Turkey", de: "Türkei" },
  TT: { en: "Trinidad and Tobago", de: "Trinidad und Tobago" },
  TV: { en: "Tuvalu", de: "Tuvalu" },
  TW: { en: "Taiwan", de: "Taiwan" },
  TZ: { en: "Tanzania (United Republic of)", de: "Tansania" },
  UA: { en: "Ukraine", de: "Ukraine" },
  UG: { en: "Uganda", de: "Uganda" },
  UM: {
    en: "United States Minor Outlying Islands",
    de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
  },
  US: { en: "United States", de: "Vereinigte Staaten" },
  UY: { en: "Uruguay", de: "Uruguay" },
  UZ: { en: "Uzbekistan", de: "Usbekistan" },
  VA: { en: "Holy See", de: "Vatikanstadt" },
  VC: {
    en: "Saint Vincent and the Grenadines",
    de: "St. Vincent und die Grenadinen",
  },
  VE: { en: "Venezuela (Bolivian Republic of)", de: "Venezuela" },
  VG: { en: "Virgin Islands (British)", de: "Britische Jungferninseln" },
  VI: { en: "Virgin Islands (U.S.)", de: "Amerikanische Jungferninseln" },
  VN: { en: "Viet Nam", de: "Vietnam" },
  VU: { en: "Vanuatu", de: "Vanuatu" },
  WF: { en: "Wallis and Futuna", de: "Wallis und Futuna" },
  WS: { en: "Samoa", de: "Samoa" },
  XK: { en: "Kosovo", de: "Kosovo" },
  YE: { en: "Yemen", de: "Jemen" },
  YT: { en: "Mayotte", de: "Mayotte" },
  ZA: { en: "South Africa", de: "Südafrika" },
  ZM: { en: "Zambia", de: "Sambia" },
  ZW: { en: "Zimbabwe", de: "Simbabwe" },
};

/** Country codes in display order (keys of COUNTRY_NAMES). */
export const getCountryCodes = (): string[] => Object.keys(COUNTRY_NAMES);

export function isValidCountryCode(code: string): boolean {
  return code in COUNTRY_NAMES;
}
